import { motion } from 'framer-motion'

export default function AutoScrollLoop({
	items,
	toRight = true,
}: {
	items: { network: string; icon: any }[]
	toRight?: boolean
}) {
	return (
		<div className="w-full overflow-hidden p-2">
			<motion.div
				className="flex w-max space-x-6"
				animate={{ x: toRight ? ['0%', '-50%'] : ['-50%', '0%'] }}
				transition={{
					duration: 50,
					ease: 'linear',
					repeat: Infinity,
				}}
			>
				{[...items, ...items].map((item, index) => (
					<div key={index} className="flex items-center gap-2 rounded-full border border-white/30 bg-white/[0.08] px-3 py-1">
						{item.icon}
						<span className="text-center text-xs text-white">{item.network}</span>
					</div>
				))}
			</motion.div>
		</div>
	)
}
